
import React from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface TooltipTextProps {
  text: string;
  tooltip: string;
}

const TooltipText = ({ text, tooltip }: TooltipTextProps) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="cursor-help border-b border-dotted border-juv-terracotta/50 hover:border-juv-terracotta">
            {text}
          </span>
        </TooltipTrigger>
        <TooltipContent className="bg-juv-deep-chestnut text-white border-juv-rose-clay max-w-xs">
          <p className="text-sm">{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TooltipText;
